import styled from '@emotion/styled';
import { Text } from '~/shared/components/Text';

export const StyledRangeContainer = styled.div(({ theme }) => ({
    minWidth: '125px',
    padding: `${theme.spaces[2]} 0`,
}));

export const StyledInputsContainer = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: '1',
    width: '100%',
    marginBottom: theme.spaces[5],
}));

export const StyledInputBox = styled.div(({ theme }) => ({
    position: 'relative',
    border: theme.borders.border,
    padding: `${theme.spaces[2]} ${theme.spaces[3]}`,
}));

export const StyledInputLabel = styled(Text)(({ theme }) => ({
    position: 'absolute',
    backgroundColor: theme.colors.light,
    left: theme.spaces[2],
    top: 0,
    transform: 'translateY(-50%)',
    padding: `0 ${theme.spaces[1]}`,
}));

export const StyledInput = styled.input(({ theme }) => ({
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.regular,
    color: theme.colors.dark,
    height: theme.spaces[5],
    borderRadius: 0,
    outline: 0,
    border: 'none',
    padding: 0,
}));

export const StyledInputCurrency = styled.span(({ theme }) => ({
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.regular,
    color: theme.colors.dark,
    height: theme.spaces[6],
}));

export const StyledInputsDashSpacer = styled.div(({ theme }) => ({
    height: '2px',
    backgroundColor: theme.colors.light30,
    margin: `0 ${theme.spaces[3]}`,
    width: theme.spaces[4],
}));

export const StyledSliderContainer = styled.div(({ theme }) => ({
    width: '100%',
    marginBottom: theme.spaces[6],
    minHeight: theme.spaces[1],
}));

export const StyledButtonsContainer = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: '1',
    width: '100%',
});
